export default "__VITE_ASSET__BlY4P5jX__"